export default __webpack_public_path__ + "static/media/close-icon.0662cf78.svg";